














import CopyStakeStreamRecordingsDisclaimer from '@/views/CopyStake/CopyStakeStreamRecordings/CopyStakeStreamRecordingsDisclaimer.vue';
import CopyStakeStreamRecordingsTable from '@/views/CopyStake/CopyStakeStreamRecordings/CopyStakeStreamRecordingsTable.vue';
import FeatureFlagRedirectMixin from '@/mixins/copy-stake/FeatureFlagRedirectMixin';

export default {
  name: 'CopyStakeStreamRecordings',
  mixins: [FeatureFlagRedirectMixin],
  components: {
    CopyStakeStreamRecordingsTable,
    CopyStakeStreamRecordingsDisclaimer
  }
};
